var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-contenido',{attrs:{"Controlador":_vm.Controlador,"BreakPoint":_vm.$vuetify.breakpoint.lgAndDown,"MostrarSubTitulo":false,"SinMenu":true,"SinToolbar":false}},[_c('portal',{attrs:{"to":"menu-principal-arriba"}}),[_c('carga',{attrs:{"Controlador":_vm.Controlador}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }